import { render } from "./StatsVideo.vue?vue&type=template&id=6aa35cb0&scoped=true"
const script = {}

import "./StatsVideo.vue?vue&type=style&index=0&id=6aa35cb0&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa35cb0"]])

export default __exports__